export enum UdfDataParameterCodes {
    vehicleManufacturerEOLProgInfoCode = 'F1A3',
    integrityValidationDataExpectedValueIVDMD = 'F016',
}
